import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { Flex } from "@similarweb/ui-components/foundations";

import ContactUsSuccessState from "app/pages/sales-intelligence/modules/top-companies/components/StyledContactUsSuccessState/StyledContactUsSuccessState";

const ANIMATION_DURATION = 500;
const ANIMATION_DELAY = 4000;

const CONTACT_US_SUCCESS_ANIMATION_DURATION = ANIMATION_DURATION * 2 + ANIMATION_DELAY;

export const StyledTopCompaniesCardWrapper = styled.div`
    padding: 16px;

    background: ${colorsPalettes.carbon[0]};
    border-radius: 6px;
    box-shadow: 0 3px 6px 0 rgba(14, 30, 62, 0.08);
`;

export const StyledCardContainerFlex = styled(Flex)`
    width: 100%;
    gap: 32px;
`;

export const StyledContactDetailsContainer = styled.div`
    position: relative;
    flex-grow: 1;
`;

export const StyledTopCompaniesContactDetailsOverlay = styled(Flex)`
    justify-content: flex-end;
    align-items: flex-end;
    position: absolute;
    padding-bottom: 10px;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
`;

export const StyledTopCompanyGeneralInfoWrapper = styled.div`
    flex: 28 0 0;
    min-width: 0;
`;

export const StyledTopCompanyContactWrapper = styled.div`
    flex: 34 0 0;
    min-width: 0;
`;

export const StyledTopCompanyOpportunitySpottedWrapper = styled.div`
    flex: 38 0 0;
    min-width: 0;
`;

export const StyledContactUsSuccessStateWrapper = styled.div`
    @keyframes fade-in-out {
        0% {
            opacity: 0;
        }
        10% {
            opacity: 1;
        }
        90% {
            opacity: 1;
        }
        100% {
            opacity: 0;
        }
    }

    opacity: 0;
    animation: fade-in-out ${CONTACT_US_SUCCESS_ANIMATION_DURATION}ms forwards;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: ${colorsPalettes.carbon[0]};
`;

export const StyledContactUsSuccessState = styled(ContactUsSuccessState)`
    padding: 8px 12px 8px 7px;
    background-color: ${colorsPalettes.carbon[0]};
`;
